import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_NHSV_LOOKUP_ACCOUNT_API_ID =
  'DASHBOARD/FETCH_NHSV_LOOKUP_ACCOUNT_API';

const apiCall = createApiCall(
  FETCH_NHSV_LOOKUP_ACCOUNT_API_ID,
  (params: { id_number: string }) => ({
    endpoint: generateEndpoint({
      host: '/api/admin/nhsv/lookup-account',
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
